import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../api";
import { usePageTitle } from "../components/common";

export default function NewsletterUnsubscribe() {
  usePageTitle("Désinscription");
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading");

  useEffect(() => {
    if (!token) { setState("error"); return; }
    api.get(`/newsletter/unsubscribe?token=${encodeURIComponent(token)}`)
      .then(() => setState("done"))
      .catch(() => setState("error"));
  }, [token]);

  return (
    <div className="container-x py-24 text-center max-w-lg" data-testid="newsletter-unsubscribe">
      {state === "loading" && <p className="text-[#7A5D58]">Un instant…</p>}
      {state === "done" && (
        <>
          <h1 className="font-serif text-3xl text-[#5A3A4B]">Tu es désinscrite ✨</h1>
          <p className="mt-4 text-[#7A5D58]">
            Tu ne recevras plus La Guidance de la Semaine. Tu peux te réinscrire à tout moment depuis l'accueil.
          </p>
          <Link to="/" className="btn-primary mt-8 inline-flex">Retour à l'accueil</Link>
        </>
      )}
      {state === "error" && (
        <>
          <h1 className="font-serif text-3xl text-[#5A3A4B]">Lien invalide</h1>
          <p className="mt-4 text-[#7A5D58]">Ce lien de désinscription n'est plus valide.</p>
          <Link to="/" className="btn-primary mt-8 inline-flex">Retour à l'accueil</Link>
        </>
      )}
    </div>
  );
}
